<template>
  <div class="wrap">
    <div class="content">
      <h2 class="title">我们的目标</h2>
      <div class="sub-title">构建高效协同的工程服务新生态</div>
      <div class="des">
        中控技术致力于通过数字化手段，整合工程服务领域优质资源，打造
        <span>“资源共享、能力互补、共生共赢”</span> 的工程生态圈
      </div>
      <div class="list">
        <div class="item">
          <div>
            <img src="@/assets/img/ecology/target1.png" alt="" />
          </div>
          <h3>全流程在线化管理</h3>
          <div class="item-des">
            从生态伙伴入驻、能力认证到任务派单、报工结算、服务记录回传、评价评级等，全链条数字化操作，提升效率与透明度
          </div>
        </div>
        <div class="item">
          <div>
            <img src="@/assets/img/ecology/target2.png" alt="" />
          </div>
          <h3>精准化资源匹配</h3>
          <div class="item-des">
            基于行业标签、能力标签智能推荐，快速精准匹配伙伴与项目机会
          </div>
        </div>
        <div class="item">
          <div>
            <img src="@/assets/img/ecology/target3.png" alt="" />
          </div>
          <h3>生态化协同发展</h3>
          <div class="item-des">
            提供行业与技术赋能，助力生态伙伴提升竞争力，共同拓展市场
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 40px 0 108px;
  .content {
    width: 1008px;
    margin: 0 auto;
  }
  .title {
    font-size: 40px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    margin: 0 0 0;
    line-height: 49px;
  }
  .sub-title {
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
    line-height: 27px;
    padding: 10px 0 31px;
  }
  .des {
    font-size: 18px;
    line-height: 32px;
    text-align: center;
    span {
      font-weight: bold;
    }
  }
}
.list {
  display: flex;
  justify-content: space-between;
  padding: 47px 0 0;
  .item {
    width: 280px;
    height: 400px;
    border-radius: 8px;
    background: #eaf2ff;
    padding: 20px;
    h3 {
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      color: rgba(0, 0, 0, 0.8);
      padding: 20px 0 40px;
      margin: 0;
      text-align: center;
    }
    .item-des {
      font-size: 18px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
